// Bilanço hesap kalemi tipi
export interface BilancoHesap {
  id: string;
  kod: string;
  label: string;
  tutar: number;
  level: 1 | 2 | 3;
  isClickable?: boolean;
  navigateTo?: string;
  isLoading?: boolean;
}

// Para formatı
export const formatCurrency = (value: number): string => {
  const isNegative = value < 0;
  const formatted = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(value));

  return isNegative ? `(${formatted})` : formatted;
};

// Toplam hesaplama - sadece level 3 (hesap) kalemlerini topla
export const calculateTotal = (data: BilancoHesap[]): number => {
  return data
    .filter(item => item.level === 3)
    .reduce((acc, item) => acc + item.tutar, 0);
};

// Ana grup toplamı hesapla
export const calculateGroupTotal = (data: BilancoHesap[], groupId: string): number => {
  const groupIndex = data.findIndex(item => item.id === groupId);
  if (groupIndex === -1) return 0;

  let total = 0;
  for (let i = groupIndex + 1; i < data.length; i++) {
    if (data[i].level === 1) break;
    if (data[i].level === 3) {
      total += data[i].tutar;
    }
  }
  return total;
};

// Renk paleti - pasta grafikler için
export const CHART_COLORS = [
  '#3b82f6', // blue
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ef4444', // red
  '#8b5cf6', // violet
  '#ec4899', // pink
  '#06b6d4', // cyan
  '#84cc16', // lime
  '#f97316', // orange
  '#6366f1', // indigo
];

// Date filter types
export type DateFilterType = 'today' | 'last1week' | 'last1month';
export type FaaliyetFilterType = 'today' | 'thisWeek' | 'thisMonth';

// Tarih hesaplama fonksiyonu
export const getDateRange = (filter: DateFilterType): { start: string; end: string } => {
  const today = new Date();
  const end = today.toISOString().split('T')[0];

  const formatDate = (d: Date) => d.toISOString().split('T')[0];

  switch (filter) {
    case 'today':
      return { start: end, end };
    case 'last1week': {
      const d = new Date(today);
      d.setDate(d.getDate() - 7);
      return { start: formatDate(d), end };
    }
    case 'last1month': {
      const d = new Date(today);
      d.setMonth(d.getMonth() - 1);
      return { start: formatDate(d), end };
    }
    default:
      return { start: end, end };
  }
};

// Faaliyet tarih aralığı hesaplama
export const getFaaliyetDateRange = (filter: FaaliyetFilterType): { start: string; end: string } => {
  const today = new Date();
  const end = today.toISOString().split('T')[0];

  const formatDate = (d: Date) => d.toISOString().split('T')[0];

  switch (filter) {
    case 'today':
      return { start: end, end };
    case 'thisWeek': {
      const d = new Date(today);
      const day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      d.setDate(diff);
      return { start: formatDate(d), end };
    }
    case 'thisMonth': {
      const d = new Date(today.getFullYear(), today.getMonth(), 1);
      return { start: formatDate(d), end };
    }
    default:
      return { start: end, end };
  }
};

// Çek tipleri
export interface CekRow {
  TUTAR?: number;
  CEKDURUM?: string;
}

// Kasa özet tipi (yeni yapı)
export interface KasaOzetRow {
  FIRMA?: string;
  SUBEADI?: string;
  DEVIR?: number;
  DONEM_GELIR?: number;
  DONEM_GIDER?: number;
  GUNCEL_BAKIYE?: number;
}

// Faaliyet Raporu tipi
export interface FaaliyetRow {
  FIRMA: string;
  ISLEM: string;
  BELGENO: string;
  TARIH: string;
  IZAHAT: string;
  ISLEMIZAHAT: string;
  FIRMAADI: string;
  FIRMAKODU: string;
  ACIKLAMA: string;
  OZELKOD1: string;
  OZELKOD2: string;
  OZELKOD3: string;
  OZELKOD4: string;
  GIREN: number;
  CIKAN: number;
  TOPLAM: number;
  TLCIKAN: number;
  TLGIREN: number;
  TLTOPLAM: number;
  BAKIYE: number;
  [key: string]: unknown;
}

// Gruplanmış faaliyet özet tipi
export interface FaaliyetOzetRow {
  TARIH: string;
  ISLEMIZAHAT: string;
  ISLEM: string;
  TLGIREN: number;
  TLCIKAN: number;
  TLTOPLAM: number;
  KAYITSAYISI: number;
  [key: string]: unknown;
}

// Belge bazlı gruplama tipi (drawer içinde)
export interface BelgeGrupRow {
  BELGENO: string;
  FIRMAADI: string;
  TARIH: string;
  ISLEM: string;
  TLGIREN: number;
  TLCIKAN: number;
  TLTOPLAM: number;
  KAYITSAYISI: number;
  detaylar: FaaliyetRow[];
  [key: string]: unknown;
}
